import { useFormik } from "formik";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "./formikValidation";
import TextArea from "../sharedComponents/textarea/textArea";
import TextInput from "../sharedComponents/inputs/textInput";

import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import Button from "../sharedComponents/buttons/button";
import { useEffect, useState } from "react";
import Lang from "../../userPreferences/staticWords";
import DateInput from "../sharedComponents/datesInputs/date";
import DropDownList from "../sharedComponents/dropdown/dropdown";
import { editTaskForm } from "../../API/store/actions/tasks";
import { useDispatch, useSelector } from "react-redux";
import MembersList, { removeItem } from "../../algorithms/listsAlogrithms";
import { resolver } from "../../API/middlewares/resolveRequests";
import { getProjectActivityForm } from "../../API/store/actions/projects/projects";
import * as actionTypes from "../../API/store/actions/actionTypes";
import { englishDate } from "../../algorithms";

const EditActivityForm = ({
  setVisible,
  data,
  setProcAdded,
  procAdded,
  userToken,
  activityId,
  projectId,
}) => {
  const dispatch = useDispatch();
  const communityId = useSelector((state) => state.community.communityId?.id);

  const saveHandler = async (values) => {
    let formData = new FormData();
    const newData = {
      NameA: values.Name,
      NameE: values.Name,
      DescriptionA: values.Description,
      DescriptionE: values.Description,
      StartDate: values.StartDate?.toString().includes("T0")
        ? values.StartDate
        : englishDate(values.StartDate) + "T00:00:00",
      EndDate: values.EndDate?.toString().includes("T0")
        ? values.EndDate
        : englishDate(values.EndDate) + "T00:00:00",
      EstimatedTime: values.EstimatedTime ? parseInt(values.EstimatedTime) : 0,
      PriorityId: parseInt(values.PriorityId),
      ProjectStatusId: parseInt(values.ProjectStatusId),
      ExecutionPercentage: values.ExecutionPercentage
        ? parseInt(values.ExecutionPercentage)
        : 0,
      adminmemberIds: values.AdminTaskMembers,
      memberIds: values.TaskMembers,
      Id: parseInt(activityId),
    };

    for (let [key, value] of Object.entries(newData)) {
      if (key == "adminmemberIds") {
        value.forEach((element) => {
          formData.append("adminmemberIds", element);
        });
      } else if (key == "memberIds") {
        value.forEach((element) => {
          formData.append("memberIds", element);
        });
      } else {
        formData.append(key, value);
      }
    }
    if (startDateError === false && endDateError === false) {
      if (values.AdminTaskMembers.length > 0) {
        setAdminListError(false);
        let res;

        res = await editTaskForm(formData, activityId, communityId, userToken);

        if (res.status <= 206) {
          setVisible(false);
          setProcAdded(!procAdded);
          dispatch({ type: actionTypes.RELOAD });
        }
      } else {
        setAdminListError(true);
      }
    }
  };

  const [dropdowns, setDrobdowns] = useState({});
  const [AdminTaskMembersList, setAdminTaskMembersList] = useState([]);
  const [TaskMembersList, setTaskMembersList] = useState([]);
  const [TaskStatusDropdownList, setTaskStatusDropdownList] = useState();
  const [PriorityDropdownList, setPriorityDropdownList] = useState();
  const formik = useFormik(
    formikSetup(initialValues, data, validationSchema, "editPopup", saveHandler)
  );
  const {
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    values,
    setFieldTouched,
    handleChange,
  } = formik;

  useEffect(() => {
    resolver(getProjectActivityForm, setDrobdowns, projectId, userToken);
  }, []);

  useEffect(() => {
    if (dropdowns?.data?.members) {
      setAdminTaskMembersList([
        ...dropdowns?.data?.members.filter(
          (member) =>
            !values.TaskMembers.some(
              (taskmember) => taskmember == member.memberId
            )
        ),
      ]);
      setTaskMembersList([
        ...dropdowns?.data?.members?.filter(
          (member) =>
            !values.AdminTaskMembers.some(
              (adminmember) => adminmember == member.memberId
            )
        ),
      ]);
    }

    if (dropdowns?.data?.priorityLkp)
      setPriorityDropdownList(dropdowns?.data?.priorityLkp);
    if (dropdowns?.data?.projectStatusLkp)
      setTaskStatusDropdownList(dropdowns?.data?.projectStatusLkp);
  }, [dropdowns]);

  const [StartDate, setStartDate] = useState(data?.startDate);
  const [EndDate, setEndDate] = useState(data?.endDate);
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const [adminListError, setAdminListError] = useState(false);

  return (
    <form onSubmit={handleSubmit}>
      <TextArea
        name={"Name"}
        containerStyle={"mb-4 col-12 align-items-center"}
        placeholder={Lang.title + "*"}
        rows="3"
        contentStyle={`scroll col-11 p-1`}
        onChange={handleChange}
        value={values.Name}
        errorMessage={formikValidation(touched, errors, "Name")}
      />

      <TextArea
        name={"Description"}
        containerStyle={"mb-4 col-12 align-items-center"}
        placeholder={Lang.Description}
        rows="3"
        contentStyle={`scroll col-11 p-1`}
        onChange={handleChange}
        value={values.Description}
        errorMessage={formikValidation(touched, errors, "Description")}
      />

      <div className="d-flex flex-xl-row justify-content-center align-items-center align-items-xl-start col-12 flex-column mt-4">
        <div
          className={`d-flex flex-column align-items-center col-12 my-2 col-xl-6`}
        >
          <p className="mb-3 px-xl-5 px-3 col-12">{Lang.periodTime + "*"}</p>
          <div className="d-flex col-12 flex-xl-row flex-column align-items-center align-items-xl-start">
            <div className={`col-12 col-xl-6 me-xl-4 px-4 px-xl-0 pe-xl-4`}>
              <DateInput
                errorMessage={
                  formikValidation(touched, errors, "StartDate") ||
                  startDateError === true
                    ? Lang.invalidDate
                    : null
                }
                placeholder={Lang.from}
                containerStyle={`col-12 col-xl-11 ${styleStart("m", 5, "xl")}`}
                name={"StartDate"}
                value={values.StartDate}
                onChange={(e) => {
                  setFieldValue("StartDate", e);
                  if (values.EndDate)
                    if (new Date(values.EndDate) >= new Date(e)) {
                      setEndDateError(false);
                      setStartDateError(false);
                    } else setStartDateError(true);
                }}
                iconPrefix="far"
                iconName="calendar"
                iconSize={22}
              />
            </div>

            <div className={`col-12 col-xl-6 px-4 px-xl-0 pe-xl-3 ps-xl-4`}>
              <DateInput
                errorMessage={
                  formikValidation(touched, errors, "EndDate") ||
                  endDateError === true
                    ? Lang.invalidDate
                    : null
                }
                placeholder={Lang.to}
                containerStyle={`col-12 col-xl-11 ${styleStart("m", 3, "xl")}`}
                value={values.EndDate}
                onChange={(e) => {
                  setFieldValue("EndDate", e);
                  if (values.StartDate)
                    if (new Date(values.StartDate) <= new Date(e)) {
                      setEndDateError(false);
                      setStartDateError(false);
                    } else setEndDateError(true);
                }}
                iconPrefix="far"
                iconName="calendar"
                iconSize={22}
              />
              {/* {endDateError === true ? (
                    <div>
                      <p className="my-2 text-danger">{Lang.invalidDate}</p>
                    </div>
                  ) : null} */}
            </div>
          </div>
        </div>

        <div className={`d-flex flex-column my-2 col-xl-3 col-12`}>
          <p className="mb-3 px-3 px-xl-2 col-12">{Lang.predictedTime}</p>
          <div
            className={`d-flex flex-xl-row flex-column align-items-xl-center  col-12 ms-xl-0 ${styleEnd(
              "p",
              4,
              "xl"
            )} } ${styleStart("p", 0, "xl")} px-4`}
          >
            <div className={`d-flex align-items-xl-center col-12 mb-2`}>
              <TextInput
                name={"EstimatedTime"}
                value={values.EstimatedTime}
                onChange={handleChange}
                errorMessage={formikValidation(
                  touched,
                  errors,
                  "EstimatedTime"
                )}
                hiddenPlaceholder={Lang["(ex:5Days)"]}
                containerStyle={`col-12 ${styleStart("m", 2, "xl")}`}
                type={"number"}
                disable={false}
                min={0}
              />
            </div>
          </div>
        </div>

        <div className={`d-flex flex-column col-xl-3 col-12 my-2`}>
          <p className="mb-3 px-3 px-xl-1 col-12">{Lang.executionPercentage}</p>
          <div
            className={`d-flex flex-xl-row flex-column align-items-xl-center col-xl-10 col-12 ms-xl-0 px-4 px-xl-0`}
          >
            <div className={`d-flex align-items-xl-center col-12 mb-2`}>
              <TextInput
                name={"ExecutionPercentage"}
                value={values.ExecutionPercentage}
                onChange={handleChange}
                errorMessage={formikValidation(
                  touched,
                  errors,
                  "ExecutionPercentage"
                )}
                hiddenPlaceholder={Lang.executionPercentage}
                containerStyle={"col-12"}
                type={"number"}
                disable={false}
                min={0}
                max={100}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex flex-xl-row justify-content-center align-items-center col-12 flex-column mb-4 mt-2">
        <DropDownList
          placeholder={Lang.priority + "*"}
          border={true}
          containerStyle={`col-12 mb-3 px-4 col-xl-6 ${styleEnd(
            "p",
            2,
            "xl"
          )} ${styleStart("p", 5, "xl")}`}
          dataSource={PriorityDropdownList}
          value={values.PriorityId}
          change={(e) => {
            setFieldValue("PriorityId", e.value);
          }}
          errorMessage={formikValidation(touched, errors, "PriorityId")}
        />

        <DropDownList
          placeholder={Lang.activityStatus + "*"}
          border={true}
          containerStyle={`col-12 mb-3 px-4 col-xl-6 ${styleStart(
            "p",
            2,
            "xl"
          )} ${styleEnd("p", 5, "xl")}`}
          dataSource={TaskStatusDropdownList}
          value={values.ProjectStatusId}
          change={(e) => {
            setFieldValue("ProjectStatusId", e.value);
          }}
          errorMessage={formikValidation(touched, errors, "ProjectStatusId")}
        />
      </div>

      <MembersList
        onChangeSearch={(e) => {
          let searchKey = e.target.value; //HERE FILTER
          setAdminTaskMembersList(
            [
              ...dropdowns?.data?.members.filter(
                (member) =>
                  ![...values.TaskMembers].some(
                    (admin) => admin.memberId == member.memberId
                  )
              ),
            ].filter((item) => item.memberName.includes(searchKey))
          );
        }}
        containerStyle="d-flex flex-column mx-xl-4 mx-3 mb-4 col-12"
        aboveTitleStyle={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}
        aboveTitle={Lang.addAdmainMembers + "*"}
        cardStyle={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
          "TitleCard"
        )}`}
        cardTitle={Lang.adminMembers}
        list={AdminTaskMembersList}
        id={"A"}
        checked={true}
        values={values.AdminTaskMembers}
        onChange={(e) => {
          if (e.target.checked) {
            setFieldValue("AdminTaskMembers", [
              ...values.AdminTaskMembers,
              parseInt(e.target.value),
            ]);
            setTaskMembersList(
              TaskMembersList.filter(
                (item) => parseInt(item.memberId) !== parseInt(e.target.value)
              )
            );
            setAdminListError(false);
          } else {
            setTaskMembersList([
              AdminTaskMembersList.find(
                (item) => parseInt(e.target.value) === parseInt(item.memberId)
              ),
              ...TaskMembersList,
            ]);
            setFieldValue(
              "AdminTaskMembers",
              removeItem(values.AdminTaskMembers, parseInt(e.target.value))
            );
            if (values.AdminTaskMembers.length > 0) {
              setAdminListError(false);
            } else {
              setAdminListError(true);
            }
          }
        }}
        listError={adminListError}
      />

      <MembersList
        onChangeSearch={(e) => {
          let searchKey = e.target.value; //HERE FILTER
          setTaskMembersList(
            [
              ...dropdowns?.data?.members.filter(
                (member) =>
                  ![...values.AdminTaskMembers].some(
                    (admin) => admin.memberId == member.memberId
                  )
              ),
            ].filter((item) => item.memberName.includes(searchKey))
          );
        }}
        containerStyle="d-flex flex-column mx-xl-4 mx-3 mb-5 col-12"
        aboveTitleStyle={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}
        aboveTitle={Lang.addMembers}
        cardStyle={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
          "TitleCard"
        )}`}
        id={"B"}
        checked={true}
        values={values.TaskMembers}
        cardTitle={Lang.Members}
        list={TaskMembersList}
        onChange={(e) => {
          if (e.target.checked) {
            setFieldValue("TaskMembers", [
              ...values.TaskMembers,
              parseInt(e.target.value),
            ]);
            setAdminTaskMembersList([
              ...AdminTaskMembersList.filter(
                (item) => parseInt(item.memberId) !== parseInt(e.target.value)
              ),
            ]);
          } else {
            setAdminTaskMembersList([
              TaskMembersList.find(
                (item) => parseInt(e.target.value) === parseInt(item.memberId)
              ),
              ...AdminTaskMembersList,
            ]);
            setFieldValue(
              "TaskMembers",
              removeItem(values.TaskMembers, parseInt(e.target.value))
            );
          }
        }}
        listError={false}
      />

      <div className="d-flex flex-sm-row justify-content-center mt-5 mb-3 col-12">
        <Button
          content={Lang.save}
          containerStyle="col-3 mx-3"
          onClick={() => {
            if (values.AdminTaskMembers.length > 0) setAdminListError(false);
            else setAdminListError(true);
          }}
          type={"submit"}
          buttonStyleType={"solid"}
        />

        <Button
          content={Lang.cancel}
          containerStyle="col-3 mx-3"
          onClick={() => {
            // setPriorityDropdownList(communityTaskForm.priorityLkp);
            // setTaskStatusDropdownList(communityTaskForm.taskStatusLkp);
            // resetForm();
            // setError(false);
            setAdminListError(false);
            setVisible(false);
          }}
        />
      </div>
    </form>
  );
};
export default EditActivityForm;
